'use client';

import {styled, Box} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const StyledTwoColumnContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(6),
  },
}));

export const StyledColumn = styled(Box)({
  flex: 1,
});
export const TwoColumnRichTextSectionContainer = styled(StyledSectionContainer)(({theme}) => ({
  color: theme.palette.text.dark,
}));
